import React, { useState } from 'react';
import { COLORS, SPACING } from '../styles/theme';
import { loadOrCreateIdentity } from '../lib/identity';
import { getProfile } from '../lib/metadata';
import { createCommunity } from '../lib/communities';
import { pubkeyShortHash } from '../lib/sanitize';
import { publishEvent } from '../lib/sync';

const inputStyle: React.CSSProperties = {
  width: '100%',
  background: '#fff',
  color: '#000',
  border: `2px inset ${COLORS.highlight}`,
  padding: SPACING.md,
  fontFamily: 'monospace',
  fontSize: '12px',
  boxSizing: 'border-box',
};

export function CommunityComposer({ onCreated }: { onCreated?: () => void }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [posting, setPosting] = useState(false);

  const handleCreate = async () => {
    if (!name.trim() || posting) return;
    setPosting(true);
    const identity = loadOrCreateIdentity();
    const username = getProfile()?.username || pubkeyShortHash(identity.publicKey);
    const community = createCommunity(name.trim(), description.trim(), identity.userId, username);
    await publishEvent('community', community);
    await publishEvent('community_member', {
      communityId: community.id,
      userId: identity.userId,
      username,
      joinedAt: Date.now(),
    });
    setName('');
    setDescription('');
    setPosting(false);
    onCreated?.();
  };

  return (
    <div style={{ padding: SPACING.lg, display: 'flex', flexDirection: 'column', gap: SPACING.md }}>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="community name"
        maxLength={60}
        style={inputStyle}
      />
      <textarea
        value={description}
        onChange={e => setDescription(e.target.value)}
        placeholder="what's this community about?"
        rows={3}
        maxLength={300}
        style={{ ...inputStyle, resize: 'vertical' }}
      />
      <button
        onClick={handleCreate}
        disabled={!name.trim() || posting}
        style={{
          padding: `${SPACING.sm} ${SPACING.lg}`,
          backgroundColor: name.trim() ? COLORS.accent : COLORS.panel,
          color: name.trim() ? '#fff' : COLORS.textMuted,
          border: `2px outset ${name.trim() ? COLORS.accent : COLORS.border}`,
          cursor: name.trim() && !posting ? 'pointer' : 'default',
          fontFamily: 'monospace',
          fontSize: '11px',
          fontWeight: 700,
          textDecoration: 'underline',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.5)',
          alignSelf: 'flex-start',
        }}
        onMouseDown={(e) => {
          if (name.trim() && !posting) {
            e.currentTarget.style.borderStyle = 'inset';
            e.currentTarget.style.boxShadow = 'inset 1px 1px 2px rgba(0,0,0,0.8)';
          }
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.borderStyle = 'outset';
          e.currentTarget.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.5)';
        }}
      >
        {posting ? '…' : 'create community'}
      </button>
    </div>
  );
}
